import { jwtDecode, JwtPayload } from 'jwt-decode'

const MILLI_MULTIPLYER = 1000
const TOKEN_GRACE_PERIOD = 5000


type CustomJWTPayload = JwtPayload & {
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': string | string[]
  UserId: string
}

export const getJwtTokenData = (token: string) => {
  const decodedToken = jwtDecode<CustomJWTPayload>(token)

  return decodedToken
}


const getTokenExpiry = (token: string): number => {
  const decodedToken = jwtDecode<CustomJWTPayload>(token)

  return (decodedToken.exp || 0) * MILLI_MULTIPLYER || 0
}

export const isTokenExpired = (token: string | null) => {
  if (!token) return true

  return getTokenExpiry(token) - TOKEN_GRACE_PERIOD <= Date.now()
}

export const getTokenTimeToExpiry = (token: string | null): number => {
  if (!token) return 0

  return Math.max(0, getTokenExpiry(token) - Date.now())
}

export const isTokenNearExpiry = (token: string | null, thresholdMs: number = 60000): boolean => {
  if (!token) return true

  return getTokenTimeToExpiry(token) <= thresholdMs
}